// media-library-image/media-library-image.js

import MediaLibraryVideoEditing from './media-library-video-editing';
import MediaLibraryVideoUi from './media-library-video-ui';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class MediaLibraryVideo extends Plugin {
    static get requires() {
        return [ MediaLibraryVideoEditing, MediaLibraryVideoUi ];
    }
}
